<div
  class="customize-snapshot-container"
  *ngIf="canCustomizeSnapshotReport$ | async"
>
  <div class="section-title">
    {{ 'CUSTOMIZE_PARTNER.SALES.SNAPSHOT_REPORT.TITLE' | translate }}
  </div>
  <div>
    <a [routerLink]="['/customize-design/customize-snapshot/']">
      {{ 'CUSTOMIZE_PARTNER.SALES.SNAPSHOT_REPORT.EDIT_TEMPLATE' | translate }}
    </a>
  </div>
  <div>
    <a [routerLink]="[wizardUrl$ | async]">
      {{ 'CUSTOMIZE_PARTNER.SALES.SNAPSHOT_REPORT.EDIT_MARKETING' | translate }}
    </a>
  </div>
  <div class="customize-snapshot-settings">
    <va-mat-table>
      <table mat-table [dataSource]="data$">
        <ng-container matColumnDef="settingName">
          <th mat-header-cell *matHeaderCellDef>
            {{
              'CUSTOMIZE_PARTNER.SALES.SNAPSHOT_REPORT.TABLE.HEADER.SETTING_LINK'
                | translate
            }}
          </th>
          <td mat-cell *matCellDef="let link">
            <a [routerLink]="link.url" *ngIf="!!link.url">
              {{ link.textKey | translate }}
            </a>
            <div *ngIf="!link.url">{{ link.textKey | translate }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="currentSettingValue">
          <th mat-header-cell *matHeaderCellDef>
            {{
              'CUSTOMIZE_PARTNER.SALES.SNAPSHOT_REPORT.TABLE.HEADER.CURRENT_VALUE'
                | translate
            }}
          </th>
          <td mat-cell *matCellDef="let link">
            {{ link.currentValue }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
      </table>
    </va-mat-table>
  </div>
</div>
<div
  class="sales-order-customize-container"
  *ngIf="canCustomizeSaleOrders$ | async"
>
  <div class="section-title">
    {{ 'CUSTOMIZE_PARTNER.SALES.SALES_ORDERS.TITLE' | translate }}
  </div>
  <div>
    <a [routerLink]="[salesOrderUrl$ | async]">
      {{ 'CUSTOMIZE_PARTNER.SALES.SALES_ORDERS.CONFIGURE' | translate }}
    </a>
  </div>
</div>
